export default function decode(str64) {
  return Buffer.from(str64, 'base64').toString();
}
